<template>
    <!-- <div class="input-wrapper col-1" :class="styleClass">
        <span class="prefixo">R$</span>
    </div> -->
    <money3 v-model="amount" :id="id" class="form-control shadow-v2 input-style" v-bind="config" />
</template>
<script>

import { useCurrencyInput } from "vue-currency-input";
import { Money3Component } from "v-money3";

export default {
    name: "CurrencyInput",
    components: {
        money3: Money3Component,
    },
    props: {
        id: String,
        options: Object,
    },
    computed: {
        config() {
            return {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                suffix: "",
                precision: 2,
                masked: false,
                disabled: false
            };
        },
    },
    data() {
        return {
            amount: '0.00',
        };
    },
    watch:{
        amount(){
            if (this.amount === null) {
                this.amount = '0.00'
            }
        }
    }
};
</script>
<style>
.input-wrapper {
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.prefix {
    height: 38px;
    line-height: 35px;
    font-weight: bold;
    width: 30px;
    color: white;
    padding-left: 5px;
    border-radius: 4px 0 0 4px !important;
    background: #9f3029;
}

.input-style {
    text-align: right;
    border-radius: 5px 5px 5px 5px !important;
}
</style>